import { useQuery } from '@tanstack/react-query'

import { fetchVenueSettlementRevenue } from '@/lib/venue/settlementApi'
import type { SettlementRevenueFilter } from '@/lib/venue/settlementViewModel'

export function settlementRevenueQueryKey(venueId: string, filter: SettlementRevenueFilter) {
  return ['venue', venueId, 'settlements', 'revenue', filter] as const
}

export function useVenueSettlementRevenue(venueId: string, filter: SettlementRevenueFilter) {
  return useQuery({
    queryKey: settlementRevenueQueryKey(venueId, filter),
    queryFn: () => fetchVenueSettlementRevenue(venueId, filter),
  })
}
